import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';

// Every change to an invitation: the clinician's invite, resend and
// withdraw, and the patient's answer. Each settles with what GraphQL answered
// or rejects with its sentence, for the screen to show where it was asked.
export function useInvitationChanges() {
  const graphql = useGraphql();

  const invite = useCallback(function({ email, name }) {
    return graphql({
      document: 'mutation Invite($email: String!, $name: String) { invitePatient(email: $email, name: $name) { id email } }',
      variables: { email, name }
    }).then(function(data) {
      return data.invitePatient;
    });
  }, [ graphql ]);

  const resend = useCallback(function(id) {
    return graphql({ document: 'mutation Resend($id: ID!) { resendInvitation(id: $id) { id } }', variables: { id } });
  }, [ graphql ]);

  const withdraw = useCallback(function(id) {
    return graphql({ document: 'mutation Withdraw($id: ID!) { withdrawInvitation(id: $id) }', variables: { id } });
  }, [ graphql ]);

  // True when the answer was taken; false when the invitation was no longer
  // open by the time it arrived.
  const respond = useCallback(function({ id, accept }) {
    return graphql({
      document: 'mutation Respond($id: ID!, $accept: Boolean!) { respondToInvitation(id: $id, accept: $accept) }',
      variables: { id, accept }
    }).then(function(data) {
      return data.respondToInvitation;
    });
  }, [ graphql ]);

  return useMemo(function() {
    return { invite, resend, withdraw, respond };
  }, [ invite, resend, withdraw, respond ]);
}
